<template>
    <footer class="footer">
        <nav class="container">
            <ul class="footer__menu" role="navigation">
                <slot></slot>
            </ul>
        </nav>
    </footer>
</template>

<script>
    export default {
        name: 'LayoutFooter',
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';

    .footer {
        &__menu {
            display:         flex;
            flex-direction:  column;
            justify-content: center;
            align-items:     flex-start;

            margin:          0;
            padding:         2rem 0.8rem;
            list-style:      none;
        }

        &__link {
            padding: 0.75rem;
        }

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            &__menu {
                flex-direction: row;
                align-items:    center;

                padding:        0;
            }

            &__link {
                padding: 1.4rem 1rem;
            }
        }
    }
</style>
